export enum ViewScope {
  personal= 'personal',
  firm = 'firm'
}
